export default {
  //#region Tổng quan
  //#endregion
  // Phiếu kết chuyển tài khoản
  AccountTransferSlipVoucher: 'AccountTransferSlipVoucher',

  Area: 'Area',

  //#region Tiền mặt tại quỹ
  Cash: 'Cash',
  CashReceipt: 'CashReceipt',
  CashPayment: 'CashPayment',
  CAReceipt: 'CAReceipt', // Phiếu thu (subsystem_id: 69)
  CAPayment: 'CAPayment', // Phiếu chi (subsystem_id: 70)
  CAFundInventory: 'CAFundInventory', // Kiểm kê quỹ
  //#endregion

  //#region Tiền gửi ngân hàng
  Cheque: 'Cheque', // Legacy - giữ lại để tương thích
  Deposit: 'Deposit', // Legacy - giữ lại để tương thích
  ChequeIssuance: 'ChequeIssuance', // Phát hành séc (subsystem_id: 72)
  AccountDeposit: 'AccountDeposit', // Nộp tiền vào tài khoản (subsystem_id: 73)
  //#endregion

  //#region Tài sản - tang vật
  InwardStock: 'InwardStock', // Legacy - giữ lại để tương thích
  OutwardStock: 'OutwardStock', // Legacy - giữ lại để tương thích
  InventoryInInward: 'InventoryInInward', // Nhập kho (subsystem_id: 76)
  InventoryInOutward: 'InventoryInOutward', // Xuất kho (subsystem_id: 77)
  InTransfer: 'InTransfer', // Chuyển kho (subsystem_id: 78)
  InventoryCount: 'InventoryCount', // Kiểm kê (subsystem_id: 79)
  //#endregion

  //#region Phân phối
  VoucherList: 'VoucherList',
  JusticeReceiptDetail: 'JusticeReceiptDetail',
  JusticeSelling: 'JusticeSelling',
  AccountTransferSlip: 'AccountTransferSlip',
  //#endregion

  //#region Sổ cái
  SubmitReport: 'SubmitReport', // Legacy - giữ lại để tương thích
  AssetEvaluation: 'AssetEvaluation', // Legacy - giữ lại để tương thích
  GeneralJournalEntry: 'GeneralJournalEntry', // Legacy - giữ lại để tương thích
  OtherTransactionVoucher: 'OtherTransactionVoucher', // Chứng từ nghiệp vụ khác (subsystem_id: 88)
  CashAndAssetDetermination: 'CashAndAssetDetermination', // Xác định tiền, tài sản (subsystem_id: 89)
  AccountClosingVoucher: 'AccountClosingVoucher', // Kết chuyển (subsystem_id: 90)
  ReportGeneration: 'ReportGeneration', // Lập báo cáo / Nộp cấp trên (subsystem_id: 91)
  //#endregion

  //#region Số dư ban đầu
  OpeningBalanceEntry: 'OpeningBalanceEntry', // Nhập số dư đầu kỳ (subsystem_id: 99)
  //#endregion

  //#region Báo cáo
  Reports: 'Reports', // Báo cáo (subsystem_id: 112)
  QuickReports: 'QuickReports', // Báo cáo nhanh (subsystem_id: 113)
  //#endregion

  //#region Danh mục
  Account: 'Account', // Hệ thống tài khoản
  AccountGroups: 'AccountGroups', // Nhóm tài khoản
  AccountTransfer: 'AccountTransfer', // Tài khoản kết chuyển
  DefaultAccount: 'DefaultAccount', // Tài khoản ngầm định
  
  // Ngân hàng
  BankAccounts: 'BankAccounts', // Danh mục tài khoản ngân hàng
  BankStandard: 'BankStandard', // Danh mục ngân hàng/kho bạc
  Currencies: 'Currencies', // Danh mục tiền tệ
  
  // Đối tượng
  ObjectList: 'ObjectList', // Danh sách đối tượng
  
  // Quyết định
  EnforcementDecision: 'EnforcementDecision', // Quyết định thi hành án
  EnforcementDecisionGroups: 'EnforcementDecisionGroups', // Nhóm quyết định thi hành án
  Judgment: 'Judgment', // Bản án
  CaseTypes: 'CaseTypes', // Loại án
  
  // Tài sản/tang vật
  AssetCatalog: 'AssetCatalog', // Danh mục tài sản/tang vật
  Warehouses: 'Warehouses', // Danh mục kho
  AssetTypes: 'AssetTypes', // Loại tài sản/tang vật
  
  // Khác
  ReceiptFormCodes: 'ReceiptFormCodes', // Mẫu số biên lai
  StatisticalCodes: 'StatisticalCodes', // Mã thống kê
  SubUnits: 'SubUnits', // Đơn vị trực thuộc
  Regions: 'Regions', // Khu vực
  //#endregion

  //#region Tệp (File menu)
  DataInformation: 'DataInformation', // Thông tin về dữ liệu
  BailiffChange: 'BailiffChange', // Thay đổi chấp hành viên
  AssignBailiffToEnforcementDecision: 'AssignBailiffToEnforcementDecision', // Chuyển CHV theo dõi QĐ THA
  VoucherValidityCheck: 'VoucherValidityCheck', // Kiểm tra tính hợp lệ của chứng từ
  BalanceValidityCheck: 'BalanceValidityCheck', // Kiểm tra tính hợp lệ của số dư
  
  // Legacy (giữ lại để tương thích)
  ChangeObject: 'ChangeObject',
  TransferExecutor: 'TransferExecutor',
  CheckValidVoucher: 'CheckValidVoucher',
  CheckValidAmount: 'CheckValidAmount',
  //#endregion

  //#region Tùy chọn nghiệp vụ (Business Options)
  GeneralOptions: 'GeneralOptions', // Tùy chọn chung
  Signatories: 'Signatories', // Người ký
  UserSignatories: 'UserSignatories', // Người ký

  AlertSettings: 'AlertSettings', // Thiết lập cảnh báo
  NumberFormatting: 'NumberFormatting', // Định dạng số
  ReportSettings: 'ReportSettings', // Báo cáo
  FptConnectOptions: 'FptConnectOptions', // Kết nối nền tảng số
  //#endregion

  //#region Hệ thống
  InfoData: 'InfoData',
  CompanyInfo: 'CompanyInfo',
  OrganizationInfo: 'OrganizationInfo', // Thông tin đơn vị
  DataManagement: 'DataManagement', // Quản lý dữ liệu
  DataMaintenance: 'DataMaintenance', // Bảo trì dữ liệu
  UserManagement: 'UserManagement', // Quản lý người dùng
  RolesAndPermissions: 'RolesAndPermissions', // Vai trò quyền hạn
  AccessLog: 'AccessLog', // Nhật ký truy cập
  AdvancedSecurity: 'AdvancedSecurity', // Bảo mật nâng cao
  PeriodClosingLock: 'PeriodClosingLock', // Khóa sổ kỳ kế toán
  PeriodClosingUnlock: 'PeriodClosingUnlock', // Bỏ khóa số kỳ kế toán
  ClosingLedger: 'ClosingLedger', // (Legacy)
  ReopeningAccountingPeriod: 'ReopeningAccountingPeriod', // (Legacy)
  //#endregion

  //#region Biên lai
  Ticket: 'Ticket',
  //#endregion

  //#region NPS Survey
  NPSForm: 'NPSForm',
  //#endregion
};
